module.exports = __webpack_public_path__ + "img/services-01.33971a02.jpg";